@use '@dixa/lib-shared-tokens/scss' as *;

.section {
  flex: 1 1 auto;
  // Make sure that on a smaller screen activity log area
  // has at least following min height of entire screen.
  min-height: 15rem;

  .root {
    height: 100%;
    padding: 0;
  }
}

.root {
  display: flex;
  flex-direction: column;
  padding: 0 var(--dixa-size-spacer-300);
  overflow: auto;
  position: relative;
}

.hasLogs:before {
  content: '';
  position: absolute;
  background-image: linear-gradient(
    to bottom,
    var(--dixa-color-neutral-300) 40%,
    transparent 60%
  );
  background-size: 2px var(--dixa-size-spacer-200);
  width: 2px;
  height: calc(100% - var(--dixa-size-spacer-500));
  top: var(--dixa-size-spacer-300);
  left: 27px;
}

.spinnerContainer {
  @include flex-centered();
  margin: var(--dixa-size-spacer-300);
}

.error {
  color: var(--dixa-color-red-500);
}
